<template>
  <div style="padding-left: 1rem">
    <!-- <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="问题">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="解答">
        <rich-text :id="index + 1" :ids="index + 1" :value="''"></rich-text>
      </el-form-item>
    </el-form> -->
    <faq-com
      v-for="(item, index) in list"
      :key="index"
      :index="index"
      :value="item"
      @changeText="changeText"
      @deleteF="deleteF"
    />
    <el-empty v-show="isShow" description="暂无数据"></el-empty>

    <div style="margin: 2rem 0">
      <el-button @click="addList" type="plain" size="mini" icon="el-icon-plus"
        >问题</el-button
      >
    </div>
    <Confirm @savePage="saveData" />
    <!--  <div class="mt-4">
          <span class="titlemenu mt-4">{{ item.title }}</span
          ><span class="title-append"></span>
        </div> -->

    <!--  <div class="classManger">
     
    </div> -->
  </div>
</template>

<script>
//import drawerDetail from "@/components/drawerDetail.vue";

import ue2 from "@/components/common/UE2.vue";
import RichText from "../components/RichText.vue";
import FaqCom from "../components/FaqCom.vue";
import Confirm from "../components/Confirm.vue";
import commonMixin from "../mixin/index.js";
export default {
  components: { ue2, RichText, FaqCom, Confirm },
  mixins: [commonMixin],
  props: {
    /*  value: {
      type: Object,
      default: {},
    }, */
    com: {
      tyoe: String,
      default: "",
    },
  },
  data() {
    return {
      list: [],
      form: {
        name: "",
        region: "",
      },
    };
  },
  methods: {
    addList() {
      console.log(this.list);
      if (!this.list) {
        this.list = [
          {
            title: "",
            content: "",
          },
        ];
      } else {
        this.list.push({
          title: "",
          content: "",
        });
      }

      this.savePage();
    },
    deleteF(index) {
      this.list.splice(index, 1);
      this.savePage();
    },
    /*  changeText(obj, index) {
      if (index >= 0) {
        this.$set(this.list, index, obj);
      }
    },
    savePage() {
      this.$emit("change", {
        type: this.com,
        subjectGuideItemDetails: [...this.list],
      });
      console.log("点击了包存");
    }, */
  },
  watch: {
    value: {
      handler(val) {
        //  debugger;
        //  console.log("传值改变了", val);
        const list = val.subjectGuideItemDetails || [];
        this.list = list;
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    /*  this.getCampusList();
    this.getPageList(); */
  },
  mounted() {
    /* window.onresize = () => {
      this.setaddDialogwidth();
    }; */
  },
};
</script>
<style scoped>
.myfade-enter-active,
.myfade-leave-active {
  transition: all 0.2s ease-out;
}
/* 进场的瞬间与离场的效果添加 */
.myfade-enter,
.myfade-leave-to {
  opacity: 0;
  transform: translateX(200px);
}
.titlemenu {
  font-weight: 600;
  font-size: 16px;
}
.title-append {
  margin-left: 1rem;
  color: #a5a5a5;
}
.mt-4 {
  margin-top: 1rem;
}
.i-icon {
  font-size: 16px;
  display: inline-block;
  color: #66b1ff;
  cursor: pointer;
}
.sidebar {
  width: 245px !important;
  border-radius: 4px;
  overflow: auto;
  background: #fff;
}
.sidebarRight {
  padding: 0px 20px !important;
}

.sidebar .title,
.sidebarRight .title {
  height: 50px;
  line-height: 50px;
  padding-left: 20px;
  border-bottom: 1px solid #e5ecf0;
}

.sidebarRight .search {
  background: #66b1ff !important;
  border: 0;
  outline: none;
  border-radius: 0;
  height: 40px;
  color: white !important;
}

.classManger .caret-wrapper {
  position: absolute;
  right: 0;
  top: -5px;
}
.table_bottom {
  margin: 20px 0;
}
.left-top-bottom {
  float: right;
  color: #4d94ff;
  font-weight: 600;
  margin-left: 10px;
  margin-top: 2px;
}
.campusManage-search {
  padding: 0px 10px;
}
.campusManage-tree {
  margin-top: 10px;
}
.span-ellipsis {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/addGuide/module/faq.vue